// src/menu/sections/appsMenu.ts
import type { AppMenuEntry } from "../types";

export const APPS_MENU: AppMenuEntry = {
  type: "group",
  key: "Apps",
  label: "Example Apps in Data",
  children: [
    {
      key: "todos",
      label: "Todos",
      path: "/todos",
      resource: "todos",
      icon: "todos",
    },
  ],
};
